
	import { Component, Prop } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Pro, SubjectAggregate } from '@shared/models';
	import { Route } from 'vue-router';
	import ProItem from './ProItem.vue';
	
	@Component({
		components: {
			ProItem,
		},
	})
	export default class ProItemList extends BaseView {

		@Prop({ default: 'Pros' })
		public title: string;

		@Prop({ default: 65 })
		public iconSize: number;

		@Prop({ default: 10 })
		public nameSize: number;

		@Prop()
		public viewRoute: Route;

		@Prop({ default: () => new Array<SubjectAggregate<Pro>>() })
		public list: Array<SubjectAggregate<Pro>>;

	}

